import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { RoleSummaryDTO } from '../interfaces/roles.interfaces';
import { RolesService } from '../services/roles.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { RegisterNewRoleModalComponent } from './modals/register-new-role-modal/register-new-role-modal.component';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss']
})
export class RolesComponent implements OnInit {

  public roles$: Observable<Array<RoleSummaryDTO>>;

  constructor(private rolesService: RolesService,
    private dialog: MatDialog){
    this.roles$ = new Observable<Array<RoleSummaryDTO>>;
  }

  ngOnInit(): void {
    this.getAllRoles();
  }

  getAllRoles(): void {
    this.roles$ = this.rolesService.getAllRoles();
  }

  openRegisterDialogModal(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = '40%';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.minWidth = '300px';
    dialogConfig.maxHeight = '90vh';

    const dialogRef = this.dialog.open(RegisterNewRoleModalComponent, dialogConfig);
    dialogRef.afterClosed()
    .subscribe(
      (refresh: boolean) => {
        if(refresh) this.getAllRoles();
      }
    )
  }



}
